export const REQUEST_GET_ALL_SO = 'so/REQUEST_GET_ALL_SO';
export const RECEIVED_ALL_SO = 'so/RECEIVED_ALL_SO';
export const RECEIVED_ERROR = 'so/RECEIVED_ERROR';